// Утилиты для работы с Google Analytics

/**
 * Отправляет кастомное событие в Google Analytics
 * @param {string} action - действие (например, 'click', 'submit', 'download')
 * @param {string} category - категория события (например, 'button', 'form', 'link')
 * @param {string} label - метка события (опционально)
 * @param {number} value - числовое значение (опционально)
 */
export const trackEvent = (action, category, label = null, value = null) => {
  if (window.gtag) {
    const eventData = {
      event_category: category,
      event_label: label,
      value: value,
    };

    // Удаляем null значения
    Object.keys(eventData).forEach(key => {
      if (eventData[key] === null) {
        delete eventData[key];
      }
    });

    window.gtag('event', action, eventData);
  }
};

/**
 * Отслеживает клик по кнопке
 * @param {string} buttonName - название кнопки
 * @param {string} location - где находится кнопка (опционально)
 */
export const trackButtonClick = (buttonName, location = null) => {
  trackEvent('click', 'button', `${buttonName}${location ? ` - ${location}` : ''}`);
};

/**
 * Отслеживает отправку формы
 * @param {string} formName - название формы
 */
export const trackFormSubmit = (formName) => {
  trackEvent('submit', 'form', formName);
};

/**
 * Отслеживает переход по внешней ссылке
 * @param {string} url - URL ссылки
 * @param {string} linkText - текст ссылки (опционально)
 */
export const trackExternalLink = (url, linkText = null) => {
  trackEvent('click', 'external_link', linkText || url);
};

/**
 * Отслеживает смену языка
 * @param {string} fromLang - с какого языка
 * @param {string} toLang - на какой язык
 */
export const trackLanguageSwitch = (fromLang, toLang) => {
  trackEvent('language_switch', 'navigation', `${fromLang} -> ${toLang}`);
};